"use strict";

define('rs/models/template',['rs/models/abstract', 'rs/models/upload', 'rs/models/document.type'], function (AbstractModel, UploadModel, DocumentType) {
  var TemplateModel = AbstractModel.extend({
    properties: ['activityDate', 'description', 'documentType', 'id', 'published', 'publishedDate', 'readOnly', 'revisionList', 'revisionNumber', 'title', 'type', 'updateUserAuthId', 'version'],
    initialize: function initialize() {
      this._super.apply(this, arguments);
    },
    setPublishedDate: function setPublishedDate(date) {
      this.set('publishedDate', date);
      if (date) {
        this.setReadOnly(true);
      } else {
        this.setReadOnly(false);
      }
    },
    requestTemplate: function requestTemplate() {
      var that = this;
      return TemplateModel.requestFormTemplate(this.getId(), this.getRevisionNumber()).then(function (template) {
        that.applyProperties(_.pick.apply(_, [template].concat(that.properties)));
        return template;
      });
    },
    requestNewEFIDs: function requestNewEFIDs(count) {
      return this.constructor.requestNewEFIDs(count);
    },
    requestLock: function requestLock() {
      return this.constructor.requestLock(this.getId());
    },
    requestUnlock: function requestUnlock() {
      return this.constructor.requestUnlock(this.getId());
    },
    save: function save(json) {
      return TemplateModel.saveFormTemplate(this.getId(), this.getRevisionNumber(), json, this.getVersion()).bind(this).tap(function (model) {
        this.setId(model.id);
        this.setRevisionNumber(model.revisionNumber);
        this.setVersion(model.version);
      });
    },
    update: function update(json) {
      return this.constructor.updateFormTemplate(json);
    },
    "delete": function _delete() {
      return TemplateModel.deleteTemplate(this.getId());
    },
    deleteRevision: function deleteRevision() {
      return TemplateModel.deleteTemplateRevisions(this.getId(), this.getRevisionNumber());
    },
    publish: function publish() {
      return TemplateModel.deserialize(this.getId(), this.getRevisionNumber());
    },
    deserialize: function deserialize() {
      return TemplateModel.deserialize(this.getId(), this.getRevisionNumber());
    },
    requestRevisions: function requestRevisions() {
      var that = this;
      return TemplateModel.requestRevisions(this.getId()).then(function (data) {
        var publishedTemplate = false,
          revs = data;
        if (that.activelyPublished) {
          for (var i = 0, len = revs.length; i < len; i++) {
            if (!publishedTemplate && revs[i].getReadOnly() || publishedTemplate && publishedTemplate.getPublishedDate() < revs[i].getPublishedDate()) {
              publishedTemplate = revs[i];
            }
          }
          if (publishedTemplate) {
            publishedTemplate.published = true;
          }
        }
        that.setRevisionList(revs);
        return revs;
      });
    },
    getDownloadLink: function getDownloadLink() {
      return this.constructor.generateDownloadLink(this.getId(), this.getRevisionNumber());
    }
  }, {
    rootURI: '/rs/api/',
    parsers: {
      'form/get/latest/:documentType': function form_get_latest_DocumentType(data, params) {
        return TemplateModel.models(data);
      },
      'form/get/published': function form_get_published(data) {
        return TemplateModel.models(data);
      },
      'form/get/published/:id': function form_get_published_Id(data) {
        return TemplateModel.models(data);
      },
      'form/getRevisions/:id': function form_getRevisions_Id(data) {
        return TemplateModel.models(data.reverse());
      },
      'form/get/:id/:revision': function form_get_Id_Revision(data) {
        return TemplateModel.model(data);
      },
      'form/modification/:studyId/:id/:revision': function form_modification_StudyId_Id_Revision(data) {
        return TemplateModel.model(data);
      },
      'form/create': function form_create(data) {
        return TemplateModel.model(data);
      },
      'form/getDocumentTypeTemplateTypes': function form_getDocumentTypeTemplateTypes(data) {
        for (var i = 0, len = data.length, dttt; i < len; i++) {
          dttt = data[i];
          dttt.templateType = TemplateModel.model(dttt.templateType);
          dttt.documentType = DocumentType.model(dttt.documentType);
        }
        return data;
      }
    },
    requestRevisions: function requestRevisions(id) {
      return this.get('form/getRevisions/' + id, {});
    },
    listLatestTemplateRevisions: function listLatestTemplateRevisions(documentType) {
      return this.get('form/get/latest/' + documentType, {});
    },
    requestPublishedTemplates: function requestPublishedTemplates() {
      return this.get('form/get/published');
    },
    requestPublishedTemplatesByStudyId: function requestPublishedTemplatesByStudyId(id) {
      return this.get('form/get/published/' + id);
    },
    createFormTemplate: function createFormTemplate(title, description, type) {
      var postObj = {
        title: title,
        description: description,
        type: type || 'Initial'
      };
      return this.post('form/create', postObj);
    },
    importFormTemplate: function importFormTemplate(options) {
      return UploadModel.upload(_.extend({}, options, {
        url: '/rs/api/form/import'
      })).bind(this).then(this.model);
    },
    saveFormTemplate: function saveFormTemplate(id, revision, json, version) {
      return this.post('form/save/' + id + '/' + revision, {
        json: json,
        version: version
      }, {
        jsonBody: true
      });
    },
    updateFormTemplate: function updateFormTemplate(json) {
      return this.put('form', json, {
        jsonBody: true
      });
    },
    deleteTemplate: function deleteTemplate(templateId) {
      return this.del('form/delete/' + templateId);
    },
    deleteTemplateRevisions: function deleteTemplateRevisions(templateId, revisionsId) {
      return this.del('form/delete/' + templateId + '/' + revisionsId);
    },
    deserialize: function deserialize(id, revision) {
      return this.get('form/publish/' + id + '/' + revision);
    },
    requestNewEFIDs: function requestNewEFIDs(count) {
      return this.get('form/getEfids/' + count);
    },
    requestFormTemplate: function requestFormTemplate(id, revision) {
      return this.get('form/get/' + id + (revision ? '/' + revision : ''), {});
    },
    requestModificationTemplate: function requestModificationTemplate(studyId, id, revision) {
      var revisionPath = revision ? '/' + revision : '';
      return this.get('form/modification/' + studyId + '/' + id + revisionPath);
    },
    requestLock: function requestLock(id) {
      return this.post('lock/template/' + id);
    },
    requestUnlock: function requestUnlock(id) {
      return this.del('lock/template/' + id);
    },
    requestTemplateTypes: function requestTemplateTypes(documentType) {
      return this.get('form/getTemplateTypes/' + documentType);
    },
    requestDownload: function requestDownload(id, revision) {
      return this.get('form/json/' + id + '/' + revision);
    },
    generateDownloadLink: function generateDownloadLink(id, revision) {
      return this.generateLink('form/json/' + id + '/' + revision);
    },
    DOCUMENT_TYPES: {
      SUBMISSION: 'Submission'
    }
  });
  return TemplateModel;
});

